import Resource from './common/resource';

class Agents extends Resource {
  path = 'agents';
}

export default Agents;
